export default __webpack_public_path__ + "media/images/404-594bec762cfe3df2fa1b86311e042fdb.png";